/** @license See the LICENSE file. */

// This code is auto-generated, do not modify this file!
const version = '0.15.4';
export {version};
